import { GET_AD_LINK_TEMPLATES } from '../../actions/AdLinkTemplate/AdLinkTemplateActions';
import { reducerWrapper } from '../../support/utils';
import { AdLinkTemplateReducerType } from './types/AdLinkTemplateReducerType';

const INIT_STATE: AdLinkTemplateReducerType = {
  loadingStatus: 0,
  error: null,
  adLinkTemplates: { data: [], pagesize: 0, total: 0 },
};

function Handler(state, action) {
  switch (action.type) {
    case GET_AD_LINK_TEMPLATES.response: {
      return {
        ...state,
        loadingStatus: 2,
        adLinkTemplates: action.data,
      };
    }
    default:
      return state;
  }
}

const AdLinkTemplate = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_AD_LINK_TEMPLATES],
  error: [GET_AD_LINK_TEMPLATES],
  resetOn: ['APP_CHANGE'],
});

export default AdLinkTemplate;
